"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const es5_1 = __importDefault(require("json-style-converter/es5"));
const options = {
    mode: 'cors',
    cache: 'default',
};
const SUCCESS = 200;
const BAD_REQUEST_OR_SERVER_ERROR = 400;
const parseResponse = (status, res) => __awaiter(void 0, void 0, void 0, function* () {
    if (status >= BAD_REQUEST_OR_SERVER_ERROR) {
        const jsonResponse = yield res.then(response => es5_1.default.snakeToCamelCase(response));
        return Promise.reject(jsonResponse);
    }
    const jsonResponse = res.then(response => es5_1.default.snakeToCamelCase(response));
    return new Promise((resolve, reject) => {
        if (status >= SUCCESS) {
            jsonResponse.then(response => resolve(response));
        }
        else {
            jsonResponse.then(response => reject(new Error(response)));
        }
    });
});
exports.default = (url, method, body = null) => {
    const newOptions = body
        ? Object.assign(Object.assign({}, options), { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }) : Object.assign({}, options);
    return fetch(url, Object.assign(Object.assign({}, newOptions), { method })).then(res => parseResponse(res.status, res.json()));
};
